import { render } from "./select-source-component.vue?vue&type=template&id=1627475a"
import script from "./select-source-component.vue?vue&type=script&lang=ts"
export * from "./select-source-component.vue?vue&type=script&lang=ts"

import "./select-source-component.vue?vue&type=style&index=0&id=1627475a&lang=less"
script.render = render

export default script